var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCardBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#7975FF",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 6.5,
    width: 5,
    height: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7507 10.25H15.2507V7.75H12.7507V10.25ZM19.0007 5.25H9.00065C8.55862 5.25 8.1347 5.42559 7.82214 5.73816C7.50958 6.05072 7.33398 6.47464 7.33398 6.91667V21.0833C7.33398 21.5254 7.50958 21.9493 7.82214 22.2618C8.1347 22.5744 8.55862 22.75 9.00065 22.75H19.0007C19.4427 22.75 19.8666 22.5744 20.1792 22.2618C20.4917 21.9493 20.6673 21.5254 20.6673 21.0833V6.91667C20.6673 6.47464 20.4917 6.05072 20.1792 5.73816C19.8666 5.42559 19.4427 5.25 19.0007 5.25Z",
    fill: "#7975FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCardBg);
export default __webpack_public_path__ + "static/media/ic_card_bg.967f1cfa40d441c3c53009761dfee26c.svg";
export { ForwardRef as ReactComponent };